import { render, staticRenderFns } from "./AIRobotAssistant.vue?vue&type=template&id=c466f10a&scoped=true&"
import script from "./AIRobotAssistant.vue?vue&type=script&lang=js&"
export * from "./AIRobotAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AIRobotAssistant.vue?vue&type=style&index=0&id=c466f10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c466f10a",
  null
  
)

export default component.exports